<script>
import { defineComponent, toRefs } from 'vue'

export default defineComponent({
  name: 'SuccessModal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { value } = toRefs(props)

    /**
     * 关闭弹窗
     */
    const close = () => {
      emit('input', false)
    }

    return {
      value,
      close
    }
  }
})
</script>

<template>
  <div class="success-modal-container">
    <van-popup v-model="value" :close-on-click-overlay="false">
      <div class="popup-container">
        <van-icon name="checked" size="56" color="#3476fe" />
        <div class="message">开启成功</div>

        <van-button class="button" @click="close">我知道了</van-button>
      </div>
    </van-popup>
  </div>
</template>

<style lang="scss" scoped>
.success-modal-container {
  .van-popup {
    border-radius: 10px;
  }
  .popup-container {
    width: 280px;
    height: 252px;
    overflow: hidden;
    padding-top: 40px;
    padding-bottom: 35px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;

    .message {
      font-size: 22px;
      font-weight: 400;
      color: #333;
      margin-top: 8px;
    }

    .button {
      width: 144px;
      height: 44px;
      margin-top: auto;
      background-color: #3476fe;
      color: #fff;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 400;
    }
  }
}
</style>
